import React, { useState } from 'react';
import Collapse from '@material-ui/core/Collapse';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { ReactComponent as ExpandLess } from '../../assets/img/svg/expand-less.svg';
import { ReactComponent as ExpandMore } from '../../assets/img/svg/expand-more.svg';
import { List, ListItem, ListItemText } from '@material-ui/core';

const theme = createMuiTheme({
  overrides: {
    MuiTypography: {
      body1: {
        fontFamily: 'GT-America-Standard-Medium'
      }
    }
  }
});

const Collapsible = ({ children, listTitle, noPadding = true, ...rest }) => {
  const [open, setOpen] = useState(true);
  const toggle = () => {
    setOpen(!open);
  };
  return (
    <ThemeProvider theme={theme}>
      <ListItem onClick={toggle} disableGutters={noPadding}>
        <ListItemText primary={listTitle} />
        {open ? <ExpandLess width={14} /> : <ExpandMore width={14} />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit {...rest}>
        <List component="div" disablePadding>
          {children}
        </List>
      </Collapse>
    </ThemeProvider>
  );
};

export default Collapsible;
